import dynamic from 'next/dynamic';

import type { ImagePreviewModalImplementationProps } from './ImagePreviewModal-implementation';

const ImagePreviewModalImplementation = dynamic(
  () =>
    import('./ImagePreviewModal-implementation').then(
      (mod) => mod.ImagePreviewModalImplementation
    ),
  { ssr: false, loading: () => null }
);

/**
 * Lightbox for a full-size attachment image. Opened from the attachment chip;
 * click outside or the X to close.
 */
export function ImagePreviewModal(props: ImagePreviewModalImplementationProps) {
  if (!props.isOpen) {
    return null;
  }

  return <ImagePreviewModalImplementation {...props} />;
}
